"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _IPC = _interopRequireDefault(require("@/libs/IPC"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let firstRun = true;
var _default = exports.default = {
  data: function data() {
    return {
      hasOtherTab: false,
      addedNetworkToExisting: false,
      server: null,
      readyToShowOptions: false
    };
  },
  computed: {
    networks() {
      return this.$state.networks;
    },
    hasFragment() {
      return window.location.hash && window.location.hash.length > 1;
    }
  },
  created: function created() {
    this.$state.setting('allowRegisterProtocolHandler', true);

    // Enable IPC listeners
    // This is used to allow opening new servers in existing tab
    _IPC.default.init();
    let server = null;
    if (this.hasFragment) {
      server = this.parseFragment();
      this.server = server;
    }
    if (server) {
      this.findOtherTabs().then(hasOtherTab => {
        if (hasOtherTab) {
          this.hasOtherTab = true;
          // Don't start the main app app here as it's already open elsewhere
        } else {
          this.listenForOtherTabs();
          this.init();
        }
        this.readyToShowOptions = true;
      });
    } else {
      this.listenForOtherTabs();
      this.init();
    }
  },
  methods: {
    listenForOtherTabs() {
      _IPC.default.on('message', e => {
        // respond to other tabs that are looking
        let msg = e.data;
        if (msg.type === 'ping' && this.networks.length > 0) {
          _IPC.default.send({
            type: 'pong'
          });
        } else if (msg.type === 'addNetwork') {
          let network = this.networks.find(n => n.name === msg.server);
          if (!network) {
            network = this.$state.addNetwork(msg.server, msg.nick || 'Guest' + Math.floor(Math.random() * 100), msg);
          }
          network.showServerBuffer('settings');
        }
      });
    },
    addEmptyNetwork() {
      let nick = 'Guest' + Math.floor(Math.random() * 100);
      let network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    async findOtherTabs() {
      // ping other tabs to try find one with added networks
      return new Promise((resolve, reject) => {
        const handleIPCMessage = e => {
          let msg = e.data;
          if (msg.type === 'pong') {
            clearTimeout(timer);
            resolve(true);
          }
        };
        let timer = setTimeout(e => {
          _IPC.default.removeListener('message', handleIPCMessage);
          resolve(false);
        }, 200);
        _IPC.default.on('message', handleIPCMessage);
        _IPC.default.send({
          type: 'ping'
        });
      });
    },
    addNetworkToExistingTab() {
      let nick = 'Guest' + Math.floor(Math.random() * 100);
      let con = this.server;
      this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      _IPC.default.send({
        nick: nick,
        server: con.server,
        port: con.port,
        tls: con.tls,
        direct: con.direct,
        password: con.password || '',
        type: 'addNetwork'
      });
      window.location.hash = '';
      this.addedNetworkToExisting = true;
    },
    addNetwork(temporary = false) {
      if (!this.server) {
        return;
      }
      let con = this.server;
      if (temporary) {
        this.$state.persistence.storageKey = null;
        this.$state.persistence.forgetState();
        this.init();
      }
      let network = this.$state.getNetworkFromAddress(con.server);
      if (!network) {
        network = this.$state.addNetwork(con.server, con.nick || 'Guest' + Math.floor(Math.random() * 100), {
          server: con.server,
          port: con.port,
          tls: con.tls,
          direct: con.direct,
          password: con.password || ''
        });
      }
      window.location.hash = '';
      network.showServerBuffer('settings');
      this.$emit('start', {
        fallbackComponent: this.constructor
      });
    },
    parseFragment() {
      if (window.location.hash.substr(1)) {
        let fragment = window.location.hash.substr(1);

        // Check to see if we're dealing with an encoded irc: uri (browsers do this
        // when clicking an IRC link)
        let uriCheck = fragment.substr(0, 7).toLowerCase();
        if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
          fragment = decodeURIComponent(fragment);
        }
        let connections = Misc.parseIrcUri(fragment);
        let con = connections[0];
        return con;
      }
      return null;
    },
    toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    async init() {
      if (!firstRun) {
        return;
      }
      firstRun = false;

      // persist the buffers in the state by default
      let persistSetting = this.$state.settings.startupOptions.remember_buffers;
      if (typeof persistSetting === 'undefined') {
        this.$state.persistence.includeBuffers = true;
      } else {
        this.$state.persistence.includeBuffers = !!persistSetting;
      }
      this.$state.persistence.watchStateForChanges();
      if (this.$state.settings.startupOptions.bouncer) {
        let controllerNet = this.$state.networks.find(n => n.is_bnc);
        if (controllerNet) {
          let bouncer = new _BouncerProvider.default(this.$state);
          bouncer.enable(controllerNet.connection.server, controllerNet.connection.port, controllerNet.connection.tls, controllerNet.connection.direct, controllerNet.connection.path);
        }
      }
      // force restricted: false as users need access
      // to network settings to add a network
      this.$state.setSetting('settings.restricted', false);
      if (this.$state.networks.length) {
        // small screen devices cannot open the statebrowser unless a network is selected
        // if any network exists in saved config make that active on startup
        this.$state.setActiveBuffer(this.$state.networks[0].id, '*');
      }
      this.$emit('start', {
        fallbackComponent: this.constructor
      });
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["startups"]) window._app_exports["components"]["startups"] = {};
window._app_exports["components"]["startups"]["Personal"]
window._app_exports.components.startups.Personal = exports.default ? exports.default : exports;
